var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryOnboardedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12C7.50067 11.1407 7.535 10.3073 7.603 9.5H16.397C16.465 10.3073 16.4993 11.1407 16.5 12C16.5038 13.5068 16.3881 15.0115 16.154 16.5H7.846C7.61231 15.0115 7.49662 13.5068 7.5 12ZM6.328 16.5C5.99137 14.1825 5.91423 11.8346 6.098 9.5H0.261005C0.0867267 10.3219 -0.000753003 11.1598 4.88231e-06 12C4.88231e-06 13.591 0.310005 15.11 0.872005 16.5H6.328ZM1.605 18H6.60001C6.859 19.217 7.195 20.33 7.59501 21.301C7.952 22.167 8.366 22.939 8.837 23.578C5.78719 22.7414 3.18846 20.7375 1.605 18ZM8.136 18H15.866C15.6598 18.9318 15.3768 19.8449 15.02 20.73C14.567 21.83 14.047 22.67 13.507 23.225C12.97 23.777 12.46 24 12 24C11.54 24 11.031 23.777 10.494 23.225C9.95401 22.671 9.434 21.83 8.981 20.73C8.62419 19.8449 8.34222 18.9318 8.136 18ZM17.401 18C17.1701 19.1282 16.837 20.2331 16.406 21.301C16.049 22.167 15.635 22.939 15.164 23.578C18.2134 22.7412 20.8108 20.7373 22.394 18H17.401ZM23.128 16.5C23.69 15.11 24 13.591 24 12C24 11.143 23.91 10.306 23.74 9.5H17.902C18.0858 11.8346 18.0086 14.1825 17.672 16.5H23.128ZM15.018 3.27C15.555 4.571 15.975 6.184 16.229 8H7.771C8.025 6.184 8.445 4.571 8.981 3.27C9.434 2.17 9.95401 1.33 10.494 0.775C11.03 0.223 11.54 0 12 0C12.46 0 12.969 0.223 13.506 0.775C14.046 1.329 14.565 2.17 15.018 3.27ZM17.744 8H23.318C22.6699 6.17357 21.5902 4.53074 20.1707 3.21133C18.7511 1.89193 17.0339 0.935005 15.165 0.422C15.635 1.061 16.05 1.833 16.407 2.699C17.017 4.182 17.479 5.992 17.744 8ZM0.684005 8H6.25801C6.52301 5.992 6.985 4.182 7.59501 2.699C7.952 1.833 8.366 1.061 8.837 0.422C6.96795 0.934863 5.25047 1.89172 3.83077 3.21114C2.41107 4.53055 1.33218 6.17345 0.684005 8Z",
    fill: "url(#paint0_linear_20_5399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_5399",
    x1: 6.92651,
    y1: 1.90478e-7,
    x2: 18.2401,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A82FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryOnboardedIcon);
export default __webpack_public_path__ + "static/media/country-onboarded-icon.bff56ca148c7834222f8a27e1b79cd53.svg";
export { ForwardRef as ReactComponent };